import { bankReconciliationDynamicMessagesEs } from "./dynamicMessages/payments/bankReconciliationDynamicMessages";

const dynamicMessages = {
  //document review
  document_review_docclass_required: `El documento {{0}} no tiene clasificación.`,
  document_review_docclass_shouldbe_oneof: `La clase del documento debe ser una de '{{0}}.'`,
  document_review_is_early_duplicate: `Por favor, revise el documento original.`,
  document_review_not_found: `Documento {{0}} no encontrado.`,
  document_review_manual_form_header_field_value_invalid: `Has actualizado el campo '{{0}}' '{{1}}' a '{{2}}'. Este campo de encabezado no se puede actualizar.`,
  document_review_manual_form_table_field_value_invalid: `Has actualizado el campo '{{0}}' '{{1}}' a '{{2}}'. Este campo de la tabla no se puede actualizar.`,
  document_review_manual_form_table_row_count_mismatch: `La tabla '{{0}}' tiene un número de filas que no coincide.`,
  document_review_manual_form_table_column_not_found: `Falta la columna en '{{0}}'.`,
  document_review_manual_form_table_row_structure_invalid: `La tabla '{{0}}' tiene una estructura de filas que no coincide.`,
  document_review_manual_form_table_not_found: `Tabla no encontrada.`,
  document_review_manual_form_table_count_mismatch: `Número de tablas no coincide.`,
  //document configuration
  mandatory_header_field_hidden: `No se puede ocultar el campo obligatorio '{{1}}' en el tipo de documento '{{0}}'.`,
  mandatory_table_field_hidden: `No se puede ocultar el campo obligatorio '{{2}}' de la tabla '{{1}}' en el tipo de documento '{{0}}'.`,
  //roles
  default_permissions_cant_be_removed:
    "Los permisos predeterminados {{0}} no se pueden eliminar.",
  only_invoice_documentclass_allowed_for_expense: `Solo se permite la clase de documento de factura para gastos.`,
  atleast_one_holded_item_glaccount_required: `Al menos un artículo retenido con cuenta GL es requerido.`,
  holded_item_glaccount_required: `La cuenta GL del artículo retenido es obligatoria para cada artículo.`,
  holded_item_not_allowed_for_accountclass_expense: `El artículo retenido no está permitido para la clase de cuenta de gastos.`,
  // Payments
  document_not_found: "No se encontró ningún documento con el/los ID(s) {{0}}",
  duplicate_document_ids_found:
    "Se encontraron ID(s) de documento duplicados {{0}}",
  paid_amount_exceed:
    "El monto pagado ({{0}}) excede el monto del documento ({{1}}) para el ID de documento {{2}}.",
  vendor_should_same_multiple_invoice_payments_on_same_transactionid:
    "El proveedor debe ser el mismo para varios pagos de facturas con el ID de transacción {{0}}.",
  deleted_document_exists:
    "El documento con el ID {{0}} ha sido eliminado y no se puede utilizar.",
  "transactionid(s)_already_recorded":
    "Los siguientes ID(s) de transacción ya han sido registrados: {{0}}.",
  document_review_duplicate_polygon:
    "Los campos {{1}} están etiquetados de forma duplicada en la página {{0}}",
  accounttype_not_match_allowed_accountypes: `El tipo de cuenta no coincide con los tipos de cuenta permitidos "{{0}}"`,
  review_document_include_schedulepaymentbill:
    "No se puede revisar el documento. Está incluido en el número de factura {{0}}, que está programado para pago.",
  "workflow-reason-required": `Se requiere una razón para el flujo de trabajo.`,

  supplier_not_found: "Proveedor no encontrado",
  supplier_is_deleted: "Proveedor eliminado",
  bankreconciliation_banktransaction_shouldbe_fullyreconciled: `La transacción bancaria debe estar completamente conciliada`,
  organization_not_found: `No se encontró organización para el usuario actual`,
  tax_type_required: `El tipo de impuesto es obligatorio`,
  invalid_tax_rate_range: `La tasa de impuesto debe estar entre 0 y 100`,
  exempt_code_required_for_zero_rate: `Se requiere un código de exención cuando la tasa de impuesto es 0%`,
  tax_code_required: `El código tributario es obligatorio`,
  duplicate_tax_rate_for_exemptcode: `Ya existe un impuesto activo con Tipo de Impuesto '{{0}}', Tasa '{{2}}%' y Código de Exención '{{1}}'`,
  duplicate_tax_rate_for_code: `Ya existe un impuesto activo con Tipo de Impuesto '{{0}}', Tasa '{{2}}%' y Código '{{1}}'`,
  tax_not_found: `Impuesto no encontrado`,
  either_tax_code_or_exempt_code_required:
    "Se requiere el código de impuesto o el código de exención",
  ...bankReconciliationDynamicMessagesEs,
};
export default dynamicMessages;
